import React, { FC, useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { getCurrentTeam, getHeaderLinks } from 'utils/role-config';
import useRoleContext from 'contexts/role.context';
import { ENUM_COKITCHEN_TEAM, ENUM_ROLE } from '@cokitchen/cokitchen-auth';
import { ReactComponent as ArrowDownIcon } from '../../assets/icons/arrow-down-icon.svg';
import { LOGISTICS_ROUTE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import { withDropdownList } from 'components/base/dropdown-list';

const DropdownList = withDropdownList<{ name: string; path: string }>();

const HeaderTab: FC = () => {
  const tabs = getHeaderLinks();
  const { role } = useRoleContext();
  const { riderCount, loadingExternalRiderCount } = useDashboardContext();

  const [allTabs, setAllTabs] = useState(tabs);
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState<null | number>(null);
  useEffect(() => {
    const hideLogisticsSettings =
      getCurrentTeam() === ENUM_COKITCHEN_TEAM.LOGISTICS && role === ENUM_ROLE.LOGISTICS_ADMIN;
    const filteredTabs = hideLogisticsSettings ? tabs.filter((t) => t.name !== 'Settings') : tabs;
    setAllTabs(filteredTabs);
  }, [role, tabs]);

  const navStyles = {
    active:
      'flex items-center mx-[15px] border-b-[3.5px] text-[#858585] cursor-pointer py-6 border-b-[#E60A2B]',
    inactive:
      'flex items-center mx-[15px] border-b-[3.5px] text-[#858585] cursor-pointer py-6 border-b-transparent'
  };
  return (
    <div className='flex justify-start items-center'>
      <div className='flex'>
        {allTabs.map(({ path, name, options }, index) => (
          <div key={index}>
            <NavLink
              to={path}
              className={({ isActive }) => (isActive ? navStyles.active : navStyles.inactive)}>
              <p className='flex gap-1'>
                {name}
                {path === LOGISTICS_ROUTE_KEYS.OVERVIEW && Number(riderCount.count) > 0 ? (
                  <span
                    className={`bg-red-5 rounded-full inline-flex justify-center items-center w-4 h-4 p-0.5 text-white text-[11px] font-semibold ${
                      loadingExternalRiderCount ? 'opacity-50' : ''
                    } animate-bounce`}>
                    {riderCount.count}
                  </span>
                ) : (
                  ''
                )}
              </p>
              <div>
                {options &&
                  (showDropdown === index ? (
                    <div className='transform rotate-180' onClick={() => setShowDropdown(null)}>
                      <ArrowDownIcon />
                    </div>
                  ) : (
                    <div onClick={() => setShowDropdown(index)}>
                      <ArrowDownIcon />
                    </div>
                  ))}
              </div>
            </NavLink>
            {showDropdown === index && options && (
              <DropdownList
                className='absolute'
                list={options}
                onSelect={(item) => {
                  navigate(item.path);
                  setShowDropdown(null);
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeaderTab;
